/*
  VittoriaBeauty · cada unidad del producto de packs es un pack N + N de regalo (máx. 3).
  Mantiene la propiedad de línea "Pack" (visible en checkout, correo y pedido) igual a la cantidad:
  1 → "1 + 1 de regalo (2 bolsas)", 2 → "2 + 2 de regalo (4 bolsas)", 3 → "3 + 3 de regalo (6 bolsas)".
  Si hay varias líneas del producto las junta en una, y nunca deja más del máximo.
  Se configura en Ajustes del tema → VittoriaBeauty · Packs.
*/
(function () {
  var cfg = window.rxPack || {};
  var HANDLE = cfg.handle;
  var MAX = cfg.max || 3;
  var UNIT = cfg.unit || 'unidades';
  var KEY = 'Pack';
  if (!HANDLE) return;
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var pending = false;

  function label(q) {
    return q + ' + ' + q + ' de regalo (' + q * 2 + ' ' + UNIT + ')';
  }

  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function packLines(cart) {
    return cart.items
      .map(function (item, i) { return { item: item, line: i + 1 }; })
      .filter(function (x) { return x.item.handle === HANDLE; });
  }

  // Vuelve a dibujar el carrito lateral de Dawn y la burbuja del ícono.
  function refresh() {
    if (location.pathname === '/cart') { location.reload(); return; }
    nativeFetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        var drawer = document.getElementById('CartDrawer');
        if (drawer && s['cart-drawer']) {
          var fresh = parser.parseFromString(s['cart-drawer'], 'text/html').getElementById('CartDrawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {});
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    var changed = false;
    getCart()
      .then(function (cart) {
        var lines = packLines(cart);
        if (!lines.length) return null;
        var total = lines.reduce(function (s, x) { return s + x.item.quantity; }, 0);
        var q = Math.min(total, MAX);
        var extra = lines.slice(1);
        var step = Promise.resolve(cart);
        if (extra.length) {
          var updates = {};
          extra.forEach(function (x) { updates[x.item.key] = 0; });
          changed = true;
          step = post('/cart/update.js', { updates: updates }).then(getCart);
        }
        return step.then(function (c) {
          var first = packLines(c)[0];
          if (!first) return null;
          var props = first.item.properties || {};
          if (first.item.quantity === q && props[KEY] === label(q)) return null;
          var next = {};
          Object.keys(props).forEach(function (k) { next[k] = props[k]; });
          next[KEY] = label(q);
          changed = true;
          return post('/cart/change.js', { line: first.line, quantity: q, properties: next });
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (changed) refresh();
        if (pending) { pending = false; sync(); }
      });
  }

  // Cada vez que el tema agrega o cambia el carrito, se revisa el pack.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      request.then(function () { setTimeout(sync, 300); }).catch(function () {});
    }
    return request;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
